export const filterItemsMock = ['sale', 'transfer', 'list', 'like', 'follow', 'bet'];
export const partialFilterItemsMock = ['sale', 'transfer', 'list', 'bet'];
export const activityTypesMock = ['My Activity', 'Following', 'All Activity'];
